import { Documento } from '@malgoos/shared';

/** Tipos da chave Pix (os mesmos de `TIPOS_CHAVE_PIX` do servidor). */
export const TIPOS_PIX = ['cpf', 'cnpj', 'email', 'telefone', 'aleatoria'] as const;
export type TipoPix = (typeof TIPOS_PIX)[number];

// Fase 2 (W19, K5): a máscara do telefone mora no núcleo desde o lote de 19/10 (também no campo de telefone do formulário).
export { mascaraTelefone } from '../../nucleo/formato';

/** Chave aleatória (EVP): 32 dígitos hexadecimais em minúsculas, com os hífens de um UUID (8-4-4-4-12) enquanto digita. */
export function mascaraChaveAleatoria(v: string): string {
  const h = v
    .toLowerCase()
    .replace(/[^0-9a-f]/g, '')
    .slice(0, 32);
  return [h.slice(0, 8), h.slice(8, 12), h.slice(12, 16), h.slice(16, 20), h.slice(20)].filter(Boolean).join('-');
}

const RE_EVP = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/i;
const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * A chave confere com o tipo? A mesma regra do servidor (`chavePixPeloTipo`): CPF e CNPJ com dígito verificador, e-mail,
 * telefone com DDD (10 ou 11 dígitos) ou internacional, aleatória como UUID. Vazio é "sem chave" (o servidor pede a chave quando
 * há tipo).
 */
export function chavePixValida(tipo: TipoPix, valor: string): boolean {
  const v = valor.trim();
  if (!v) return true;
  switch (tipo) {
    case 'cpf':
    case 'cnpj': {
      const d = Documento.tryCreate(v);
      return d.ok && d.valor.tipo === tipo;
    }
    case 'email':
      return RE_EMAIL.test(v);
    case 'telefone': {
      const d = v.replace(/\D/g, '');
      return v.startsWith('+') ? d.length >= 8 && d.length <= 15 : d.length === 10 || d.length === 11;
    }
    case 'aleatoria':
      return RE_EVP.test(v);
  }
}
